/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./pages/Home.vue'),
          meta: {
            requires: {
              isAuth: true
            }
          }
        },
        {
          path: '/settings',
          name: 'settings',
          component: () => import('./pages/settings/Me.vue'),
          meta: {
            requires: {
              isAuth: true
            },
            pageTitle: 'Настройки профиля',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Настройки профиля', active: true }
            ]
          }
        },
        {
          path: '/company',
          name: 'company',
          component: () => import('./pages/company/Company.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.show'
            },
            pageTitle: 'Компания',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Настройки компании', active: true }
            ]
          }
        },
        {
          path: '/operators',
          name: 'operators',
          component: () => import('./pages/operators/OperatorsList.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.operator.list'
            },
            pageTitle: 'Операторы',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Список операторов', active: true }
            ]
          }
        },
        {
          path: '/operators/add',
          name: 'operators_add',
          component: () => import('./pages/operators/OperatorsAdd.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.operator.manage'
            },
            pageTitle: 'Добавление оператора',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Список операторов', url: '/operators' },
              { title: 'Добавление оператора', active: true }
            ]
          }
        },
        {
          path: '/operators/edit/:email',
          name: 'operators_edit',
          component: () => import('./pages/operators/OperatorsEdit.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.operator.manage'
            },
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Список операторов', url: '/operators' },
              { title: 'Редактирование оператора', active: true }
            ],
            pageTitle: 'Редактирование оператора'
          }
        },
        {
          path: '/groups',
          name: 'groups',
          component: () => import('./pages/groups/GroupsList.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.manage'
            },
            pageTitle: 'Группы операторов',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Группы операторов', active: true }
            ]
          }
        },
        {
          path: '/reports',
          name: 'reports',
          component: () => import('./pages/statistics/Statistics.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'report.manage'
            },
            pageTitle: 'Отчетность',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Отчетность', active: true }
            ]
          }
        },
        {
          path: '/groups/add',
          name: 'groups_add',
          component: () => import('./pages/groups/GroupsAdd.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.manage'
            },
            pageTitle: 'Создание группы',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Группа операторов', url: '/groups' },
              { title: 'Создание группы', active: true }
            ]
          }
        },
        {
          path: '/groups/edit/:groupSlug',
          name: 'groups_edit',
          component: () => import('./pages/groups/GroupsEdit.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.manage'
            },
            pageTitle: 'Создание группы',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Группа операторов', url: '/groups' },
              { title: 'Настройка группы', active: true }
            ]
          }
        },
        {
          path: '/channels',
          name: 'channels',
          component: () => import('./pages/channels/ChannelsList.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.channel.list'
            },
            pageTitle: 'Мои каналы',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Каналы общения', active: true }
            ]
          }
        },
        {
          path: '/channels/add',
          name: 'channels_add',
          component: () => import('./pages/channels/ChannelsAdd.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.channel.manage'
            },
            pageTitle: 'Создание канала',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Каналы общения', url: '/channels' },
              { title: 'Создание канала', active: true }
            ]
          }
        },
        {
          path: '/channels/edit/:channelSlug',
          name: 'channels_edit',
          component: () => import('./pages/channels/ChannelsEdit.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.channel.manage'
            },
            pageTitle: 'Настройка канала',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Каналы общения', url: '/channels' },
              { title: 'Настройка канала', active: true }
            ]
          }
        },
        {
          path: '/channels/:channelSlug/wa-chat/add',
          name: 'channels_wa-chat_add',
          component: () => import('./pages/channels/ChannelsMessangerAdd.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.channel.manage'
            },
            pageTitle: 'Добавление мессенджера в канал',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Каналы общения', url: '/channels' },
              { title: 'Добавление мессенджера в канал', active: true }
            ]
          }
        },
        {
          path: '/channels/:channelSlug/wa-chat/edit',
          name: 'channels_wa-chat_edit',
          component: () => import('./pages/channels/ChannelsMessangerEdit.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.channel.manage'
            },
            pageTitle: 'Редактирование мессенджера',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Каналы общения', url: '/channels' },
              { title: 'Редактирование мессенджера', active: true }
            ]
          }
        },
        {
          path: '/channels/:channelSlug/bachata/add',
          name: 'channels_bachata_add',
          component: () => import('./pages/channels/ChannelsBachataAdd.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.channel.manage'
            },
            pageTitle: 'Добавление мессенджера в канал',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Каналы общения', url: '/channels' },
              { title: 'Добавление мессенджера в канал', active: true }
            ]
          }
        },
        {
          path: '/channels/:channelSlug/bachate/edit',
          name: 'channels_bachata_edit',
          component: () => import('./pages/channels/ChannelsBachataEdit.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.channel.manage'
            },
            pageTitle: 'Редактирование мессенджера',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Каналы общения', url: '/channels' },
              { title: 'Редактирование мессенджера', active: true }
            ]
          }
        },
        {
          path: '/channels/:channelSlug/waba/add',
          name: 'channels_waba_add',
          component: () => import('./pages/channels/ChannelsWabaAdd.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.channel.manage'
            },
            pageTitle: 'Добавление мессенджера в канал',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Каналы общения', url: '/channels' },
              { title: 'Добавление мессенджера в канал', active: true }
            ]
          }
        },
        {
          path: '/channels/:channelSlug/waba/edit',
          name: 'channels_waba_edit',
          component: () => import('./pages/channels/ChannelsWabaEdit.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.channel.manage'
            },
            pageTitle: 'Редактирование мессенджера',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Каналы общения', url: '/channels' },
              { title: 'Редактирование мессенджера', active: true }
            ]
          }
        },
        {
          path: '/channels/:channelSlug/calltouch/add',
          name: 'channels_calltouch_add',
          component: () => import('./pages/channels/ChannelsCallTouchAdd.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.channel.manage'
            },
            pageTitle: 'Интеграция с CallTouch',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Каналы общения', url: '/channels' },
              { title: 'Интеграция с CallTouch', active: true }
            ]
          }
        },
        {
          path: '/channels/:channelSlug/calltouch/edit',
          name: 'channels_calltouch_edit',
          component: () => import('./pages/channels/ChannelsCallTouchEdit.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.channel.manage'
            },
            pageTitle: 'Интеграция с CallTouch',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Каналы общения', url: '/channels' },
              { title: 'Интеграция с CallTouch', active: true }
            ]
          }
        },
        {
          path: '/scenarios',
          name: 'scenarios',
          component: () => import('./pages/scenarios/ScenariosList.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.manage'
            },
            pageTitle: 'Список чат-ботов',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Список чат-ботов', active: true }
            ]
          }
        },
        {
          path: '/scenarios/add',
          name: 'scenarios_add',
          component: () => import('./pages/scenarios/ScenariosAdd.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.manage'
            },
            pageTitle: 'Список чат-ботов',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Список чат-ботов', url: '/scenarios' },
              { title: 'Создание чат-бота', active: true }
            ]
          }
        },
        {
          path: '/scenarios/edit/:scenarioSlug',
          name: 'scenarios_edit',
          component: () => import(/* webpackChunkName: "steps" */ './pages/scenarios/ScenariosEdit.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'company.manage'
            },
            pageTitle: 'Настройка чат-бота',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Список чат-ботов', url: '/scenarios' },
              { title: 'Настройка чат-бота', active: true }
            ]
          }
        },
        {
          path: '/clients',
          name: 'clients',
          component: () => import('./pages/clients/ClientsList.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true
            },
            pageTitle: 'Клиенты',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Клиенты', active: true }
            ]
          }
        },
        {
          path: '/chats/:client_id?',
          name: 'chats',
          component: () => import(/* webpackChunkName: "chats" */ './pages/messenger/Messenger.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true
            },
            pageTitle: 'Чат',
            disableTitle: true
          }
        },
        {
          path: '/bulk-delivery/tasks',
          name: 'bulk_delivery_tasks',
          component: () => import('./pages/bulk-delivery/BulkDeliveryTasks.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'bulk_delivery.manage'
            },
            pageTitle: 'Рассылки',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Рассылки', active: true }
            ]
          }
        },
        {
          path: '/bulk-delivery/tasks/add',
          name: 'bulk_delivery_tasks_add',
          component: () => import('./pages/bulk-delivery/BulkDeliveryTasksAdd.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'bulk_delivery.manage'
            },
            pageTitle: 'Создать рассылку',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Рассылки', url: '/bulk-delivery/tasks' },
              { title: 'Создать рассылку', active: true }
            ]
          }
        },
        {
          path: '/bulk-delivery/tasks/:slug',
          name: 'bulk_delivery_task',
          component: () => import('./pages/bulk-delivery/BulkDeliveryTask.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'bulk_delivery.manage'
            },
            pageTitle: 'Рассылка',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Рассылки', url: '/bulk-delivery/tasks' },
              { title: 'Массовая рассылка', active: true }
            ]
          }
        },
        {
          path: '/widgets',
          name: 'widgets',
          component: () => import('./pages/widgets/WidgetsList.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'widget.manage'
            },
            pageTitle: 'Мои виджеты',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Виджеты', active: true }
            ]
          }
        },
        {
          path: '/widgets/add',
          name: 'widgets_add',
          component: () => import('./pages/widgets/WidgetsAdd.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'widget.manage'
            },
            pageTitle: 'Создание виджета',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Виджеты', url: '/widgets' },
              { title: 'Создание виджета', active: true }
            ]
          }
        },
        {
          path: '/widgets/edit/:widgetSlug',
          name: 'widgets_edit',
          component: () => import('./pages/widgets/WidgetsEdit.vue'),
          meta: {
            requires: {
              isAuth: true,
              isEmailVerified: true,
              permission: 'widget.manage'
            },
            pageTitle: 'Настройка виджета',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Виджеты', url: '/widgets' },
              { title: 'Настройка виджета', active: true }
            ]
          }
        }
      ]
    },
    // =============================================================================
    // AUTH LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/Auth.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/auth/login',
          name: 'login',
          component: () => import('@/pages/auth/Login.vue'),
          meta: {
            requires: {
              isNotAuth: true
            }
          }
        },
        {
          path: '/auth/registration',
          name: 'registration',
          component: () => import('@/pages/auth/Registration.vue'),
          meta: {
            requires: {
              isNotAuth: true
            }
          }
        },
        {
          path: 'auth/password_recovery',
          name: 'password_recovery',
          component: () => import('@/pages/auth/PasswordRecovery.vue'),
          meta: {
            requires: {
              isNotAuth: true
            }
          }
        },
        {
          path: 'auth/password/reset',
          name: 'password_reset',
          component: () => import('@/pages/auth/PasswordReset.vue'),
          meta: {
            requires: {
              isNotAuth: true
            }
          }
        },
        {
          path: 'auth/verify/:verify(.*)',
          name: 'verify',
          component: () => import('@/pages/auth/Verify.vue')
        },
        {
          path: 'auth/need-verify',
          name: 'need_verify',
          component: () => import('@/pages/auth/NeedVerifyEmail.vue'),
          meta: {
            requires: {
              isAuth: true
            }
          }
        }
      ]
    },
    // =============================================================================
    // ERROR LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/Error.vue'),
      children: [
        {
          path: '/internal-server-error',
          name: 'page-error-500',
          component: () => import('@/pages/errors/500.vue')
        },
        {
          path: '/no-permissions',
          name: 'no-permissions',
          component: () => import('@/pages/errors/NoPermissions.vue')
        },
        {
          path: '*',
          name: 'page-error-404',
          component: () => import('@/pages/errors/404.vue')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {

  const requires = to.meta && to.meta.requires ? to.meta.requires : {}

  // Если открываем страницу, которая требует авторизированного пользователя
  if (requires.isAuth) {
    if (store.getters.isAuth) {
      // Проверка на верификацию почты
      if (
        requires.isEmailVerified &&
        !store.getters.isEmailVerified &&
        to.name !== 'need_verify'
      ) {
        next({name: 'need_verify'})
        return false
      }

      // Проверка на разрешение страницы
      if (
        requires.permission &&
        store.getters.isAuthUserCompany &&
        !store.getters.authUserCompany.permissions.includes(requires.permission)
      ) {
        next({name: 'no-permissions'})
        return false
      }
      next()
    } else {
      next({name: 'login'})
    }
  // Если открываем страницу, которая требует НЕ авторизированного пользователя
  } else if (requires.isNotAuth) {
    if (!store.getters.isAuth) {
      next()
    } else {
      next({name: 'home'})
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.classList.add('hiding')
    setTimeout(() => {
      appLoading.classList.add('is-ready')
    }, 600)
  }
})

export default router
